<template>
  <v-container fluid>
    <!-- Row Create/Edit -->
    <v-row justify="center" class="ma-1">
      <v-col cols="4">
        <v-autocomplete
          v-model="selected_item.id_tipo"
          dense
          hide-details
          :items="items_tipo"
          item-text="des"
          item-value="id_tabella"
        >
          <template #label>
            <span>Tipo<strong>* </strong></span>
            <a @click.stop style="pointer-events: all">
              <Modules
                v-on:dialogModules="aggiornaAutocomplete"
                tipo="EG_TIPO_VEICOLO"
                nome="Tipo"
                setaction="settabelle"
                getaction="gettabelle"
                controller="Magazzino"
                filter="validita = 1"
                :dati="[{ des: '' }]"
              />
            </a>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-text-field
          v-model="selected_item.targa"
          label="Targa"
          dense
          hide-details
        />
      </v-col>
      <v-col cols="2">
        <v-text-field
          v-model="selected_item.codice_interno"
          label="Codice"
          dense
          hide-details
        />
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          v-model="selected_item.id_marca"
          dense
          hide-details
          :items="items_marca"
          label="Marca"
          item-text="des"
          item-value="id_tabella"
        >
          <template #label>
            <span>Marca<strong>* </strong></span>
            <a @click.stop style="pointer-events: all">
              <Modules
                v-on:dialogModules="aggiornaAutocomplete"
                tipo="EG_MARCA_VEICOLO"
                nome="Marca"
                setaction="settabelle"
                getaction="gettabelle"
                controller="Magazzino"
                filter="validita = 1"
                :dati="[{ des: '' }]"
              />
            </a>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          v-model.number="selected_item.modello"
          dense
          hide-details
          :items="items_modello"
          label="Modello"
          item-text="des"
          item-value="id_tabella"
        >
          <template #label>
            <span>Modello<strong>* </strong></span>
            <a @click.stop style="pointer-events: all">
              <Modules
                v-on:dialogModules="aggiornaAutocomplete"
                tipo="EG_MODELLO_VEICOLO"
                nome="Modello"
                setaction="settabelle"
                getaction="gettabelle"
                controller="Magazzino"
                filter="validita = 1"
                :dati="[{ des: '' }]"
              />
            </a>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="selected_item.telaio"
          label="Telaio"
          dense
          hide-details
          class="mt-3"
        />
      </v-col>
      <v-col cols="3">
        <v-autocomplete
          v-model="selected_item.id_azienda"
          dense
          hide-details
          :items="items_azienda"
          item-text="des"
          item-value="id_tabella"
          class="mt-3"
        >
          <template #label>
            <span>Azienda<strong>* </strong></span>
            <a @click.stop style="pointer-events: all">
              <Modules
                v-on:dialogModules="aggiornaAutocomplete"
                tipo="EG_AZIENDA_VEICOLO"
                nome="Azienda"
                setaction="settabelle"
                getaction="gettabelle"
                controller="Magazzino"
                filter="validita = 1"
                :dati="[{ des: '' }]"
              />
            </a>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          v-model="selected_item.id_alimentazione"
          dense
          hide-details
          :items="items_alimentazione"
          item-text="des"
          item-value="id_tabella"
          class="mt-3"
        >
          <template #label>
            <span>Alimentazione<strong>* </strong></span>
            <a @click.stop style="pointer-events: all">
              <Modules
                v-on:dialogModules="aggiornaAutocomplete"
                tipo="EG_ALIMENTAZIONE_VEICOLO"
                nome="Alimentazione"
                setaction="settabelle"
                getaction="gettabelle"
                controller="Magazzino"
                filter="validita = 1"
                :dati="[{ des: '' }]"
              />
            </a>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          v-model="selected_item.id_tipo_patente"
          dense
          hide-details
          :items="items_patente"
          item-text="descrizione"
          item-value="id_abilitazione"
          class="mt-3"
        >
          <template #label>
            <span>Patente<strong>* </strong></span>
            <a @click.stop style="pointer-events: all">
              <Modules
                v-on:dialogModules="aggiornaAutocomplete"
                tipo="CONDUTTORE_ABILITAZIONE"
                nome="Patente"
                setaction="settabelle"
                getaction="gettabelle"
                controller="Magazzino"
                filter="validita = 1"
                :dati="[{ des: '' }]"
              />
            </a>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-text-field
          type="number"
          v-model.number="selected_item.potenza"
          label="Potenza (cv)"
          dense
          class="mt-3"
          hide-details
        />
      </v-col>
      <v-col cols="2">
        <v-text-field
          v-model="selected_item.assetId"
          label="Asset_id"
          dense
          hide-details
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          dense
          type="date"
          hide-details
          label="Immatricolazione"
          v-model="selected_item.immatricolazione"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          dense
          type="date"
          hide-details
          label="Scadenza assicurazione"
          v-model="selected_item.scadenza_assicurazione"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          dense
          type="date"
          hide-details
          label="Scadenza bollo"
          v-model="selected_item.scadenza_tassa_circolazione"
        />
      </v-col>
    </v-row>
    <v-row justify="center" class="ma-1">
      <v-col cols="2">
        <v-text-field
          type="number"
          v-model.number="selected_item.massa"
          label="Massa (kg)"
          dense
          hide-details
          class="mt-3"
        />
      </v-col>
      <v-col cols="2">
        <v-text-field
          type="number"
          v-model.number="selected_item.massa_rimorchio"
          label="Massa Rimorchio (kg)"
          dense
          hide-details
          class="mt-3"
        />
      </v-col>
      <v-col cols="2">
        <v-text-field
          type="number"
          v-model.number="selected_item.massa_pieno_carico"
          label="Massa Pieno Carico (kg)"
          dense
          hide-details
          class="mt-3"
        />
      </v-col>
      <v-col cols="2">
        <v-text-field
          type="number"
          v-model.number="selected_item.lunghezza"
          label="Lunghezza (m)"
          dense
          hide-details
          class="mt-3"
        />
      </v-col>
      <v-col cols="2">
        <v-text-field
          type="number"
          v-model.number="selected_item.larghezza"
          label="Larghezza (m)"
          dense
          hide-details
          class="mt-3"
        />
      </v-col>
      <v-col cols="2">
        <v-text-field
          type="number"
          v-model.number="selected_item.altezza"
          label="Altezza (m)"
          dense
          hide-details
          class="mt-3"
        />
      </v-col>
      <v-col cols="2">
        <v-checkbox
          dense
          hide-details
          v-model.number="selected_item.ragno"
          :true-value="1"
          :false-value="0"
          label="Ragno"
          class="mt-3"
        />
      </v-col>
      <v-col cols="2">
       <v-text-field
          v-model="selected_item.priorita"
          label="Priorità"
          dense
          type="number"
          hide-details
          class="mt-3"
        />
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="selected_item.note"
          label="Note"
          dense
          hide-details
          class="mt-3"
        />
      </v-col>
    </v-row>
    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Veicolo {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }
  // Metodo per resettare tutti i campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_macchina_extra", default_val: -1 },
      { nome: "id_macchina", default_val: -1 },
      { nome: "assetId", default_val: null },
      { nome: "codice_interno", default_val: null },
      { nome: "id_tipo", default_val: null },
      { nome: "targa", default_val: "" },
      { nome: "ragno", default_val: 0 },
      { nome: "id_marca", default_val: null },
      { nome: "modello", default_val: null },
      { nome: "telaio", default_val: "" },
      { nome: "id_azienda", default_val: "" },
      { nome: "immatricolazione", default_val: null },
      { nome: "scadenza_assicurazione", default_val: null },
      { nome: "scadenza_tassa_circolazione", default_val: null },
      { nome: "potenza", default_val: null },
      { nome: "id_alimentazione", default_val: null },
      { nome: "id_tipo_patente", default_val: null },
      { nome: "massa", default_val: null },
      { nome: "um_massa", default_val: 388 },
      { nome: "massa_rimorchio", default_val: null },
      { nome: "um_massa_rimorchio", default_val: 388 },
      { nome: "massa_pieno_carico", default_val: null },
      { nome: "um_massa_pieno_carico", default_val: 388 },
      { nome: "lunghezza", default_val: null },
      { nome: "larghezza", default_val: null },
      { nome: "altezza", default_val: null },
      { nome: "note", default_val: "" },
      { nome: "priorita", default_val: "" },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

export default {
  name: "QLGeneraleVeicoli",
  components: {
    SnackbarQV,
    Modules: () => import("../../../../components/TOOLS/Modules"),
  },
  props: {
    selected_item: Veicolo,
    items_tipo: Array,
    items_marca: Array,
    items_modello: Array,
    items_azienda: Array,
    items_alimentazione: Array,
    items_patente: Array,
  },
  data() {
    return {
      overlay: false,
    };
  },
  watch: {
    variabile: {
      immediate: true,

      handler() {},
    },
  },

  methods: {
    // metodo per riempire gli array degli autocomplete
    aggiornaAutocomplete() {
      this.$emit("aggiornaAutocomplete");
    },
  },
  created() {},
  mounted() {
    this.selected_item.modello =
      this.selected_item.modello != null
        ? parseInt(this.selected_item.modello)
        : null;
  },
};
</script>